import {computed, Inject, Injectable, InjectionToken} from '@angular/core';
import {toSignal} from '@angular/core/rxjs-interop';
import {BehaviorSubject, Subject, map} from 'rxjs';
import {AuthorizationState} from '../../typings';
import {ILoginResponse, JwtToken} from '../APIs';

// AuthStore State injection token
export type AuthStoreStateInjectionToken = {
	signal$: Signal<AuthorizationState>;
	init: (signal$: Signal<AuthorizationState>) => void;
};
export const AUTH_STORE_STATE_INJECTION_TOKEN = new InjectionToken<AuthStoreStateInjectionToken>('AuthStoreState', {
	providedIn: 'root',
	factory: () => {
		const obj = {
			signal$: null as Signal<AuthorizationState>,
			init: (signal$: Signal<AuthorizationState>) => {
				if (!obj.signal$) {
					obj.signal$ = signal$;
				}
			},
		};
		return obj;
	},
});

@Injectable({
	providedIn: 'root',
})
export class ActiveUserConnectorService {
	public readonly activeUserLoggedIn$ = new BehaviorSubject<{
		authResponse: ILoginResponse;
		jwt: JwtToken;
	}>(null);
	public readonly activeUserLoggedOut$ = new Subject<void>();

	constructor(@Inject(AUTH_STORE_STATE_INJECTION_TOKEN) private readonly authStoreState: AuthStoreStateInjectionToken) {}

	public readonly isAuthenticatedObs = this.activeUserLoggedIn$.pipe(map(Boolean));
	private readonly isAuthenticatedSignal = toSignal(this.isAuthenticatedObs);

	public readonly isAuthenticated = computed(() => {
		const authStoreState = this.authStoreState.signal$();
		return Boolean(authStoreState.accessToken) && Boolean(authStoreState.authLoad.loggedIn);
	});
}
